import { put, takeLatest } from 'redux-saga/effects'
import request from '@utils/request'
import { rootActions } from '@app-store/slices'
import { Action } from 'redux'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.ui.authSlider

function* fetchSliderSaga({ payload }: TaskAction) {
    try {
        const response = yield request.get('/api/public', { data: payload })
        yield put(onSuccess(response?.body?.slide_show))
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* authSliderSaga(): any {
    yield takeLatest<TaskAction>(onRequest, fetchSliderSaga)
}
export default authSliderSaga
